import { EventName } from '@lit/react';
import { BlocksTableCell } from 'blocks-nextjs/blocks-web-components/components/table-cell/table-cell';
import { BlocksRowCellSelectEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTableCell = createComponent({
  react: React,
  tagName: 'cat-table-cell',
  elementClass: BlocksTableCell,
  events: {
    onBlRowCellSelect: 'bl-row-cell-select' as EventName<BlocksRowCellSelectEvent>
  }
});
